(function () {
  const DURATION_MS = 1600;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseStatValue(raw) {
    const text = String(raw).trim();
    const match = text.match(/^([^\d-]*?)(-?[\d,]+(?:\.\d+)?)(.*)$/);
    if (!match) return null;

    const numberPart = match[2].replace(/,/g, '');
    const target = parseFloat(numberPart);
    if (Number.isNaN(target)) return null;

    const [intPart, fracPart] = numberPart.split('.');
    return {
      prefix: match[1],
      target,
      suffix: match[3],
      decimals: fracPart ? fracPart.length : 0,
      padLength: intPart.replace(/^-/, '').length,
    };
  }

  function formatNumber(value, parsed) {
    let out =
      parsed.decimals > 0
        ? value.toFixed(parsed.decimals)
        : String(Math.round(value));

    if (parsed.decimals === 0 && parsed.padLength > 1) {
      out = String(Math.round(value)).padStart(parsed.padLength, '0');
    }

    return parsed.prefix + out + parsed.suffix;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateStat(el, parsed) {
    const start = performance.now();

    function frame(now) {
      const progress = Math.min(1, (now - start) / DURATION_MS);
      const current = parsed.target * easeOutCubic(progress);
      el.textContent = formatNumber(current, parsed);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatNumber(parsed.target, parsed);
        el.classList.remove('relab-clinical-stats__value--counting');
      }
    }

    el.classList.add('relab-clinical-stats__value--counting');
    requestAnimationFrame(frame);
  }

  function prepareStat(el) {
    const raw = el.dataset.clinicalStatValue || el.textContent;
    const parsed = parseStatValue(raw);
    if (!parsed) return null;

    el.dataset.clinicalStatValue = raw;

    if (reducedMotion) return null;

    el.textContent = formatNumber(0, parsed);
    return parsed;
  }

  function initSection(root) {
    if (root.dataset.clinicalStatsInit === '1') return;
    root.dataset.clinicalStatsInit = '1';

    const elements = root.querySelectorAll('[data-clinical-stat-value]');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          observer.unobserve(el);

          if (el.dataset.clinicalStatAnimated === '1') return;
          el.dataset.clinicalStatAnimated = '1';

          const parsed = parseStatValue(el.dataset.clinicalStatValue);
          if (!parsed) return;

          const delay = parseInt(el.dataset.clinicalStatDelay || '0', 10);

          if (reducedMotion) {
            el.textContent = formatNumber(parsed.target, parsed);
            return;
          }

          window.setTimeout(function () {
            animateStat(el, parsed);
          }, delay);
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
    );

    elements.forEach(function (el, index) {
      const parsed = prepareStat(el);
      if (!parsed) return;
      el.dataset.clinicalStatDelay = String(index * 120);
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-relab-clinical-stats]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-relab-clinical-stats]');
    if (!root && event.target.matches && event.target.matches('[data-relab-clinical-stats]')) {
      root = event.target;
    }
    if (root) initSection(root);
  });
})();
